module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-bar-down-f2e86ca3.svg";